import { render } from "./AboutPthFerizaj.vue?vue&type=template&id=28277f38&scoped=true"
import script from "./AboutPthFerizaj.vue?vue&type=script&lang=js"
export * from "./AboutPthFerizaj.vue?vue&type=script&lang=js"

import "./AboutPthFerizaj.vue?vue&type=style&index=0&id=28277f38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28277f38"]])

export default __exports__